import React from "react";

interface NotificationProps {
	message: string;
	show: boolean;
	type: "success" | "error";
}

const Notification: React.FC<NotificationProps> = ({ message, show, type }) => {
	return (
		// Gallery toast: near-black card, quiet fade, a thin accent edge (gold = success, muted = error).
		// No bright green/red; z above the header; never blocks clicks when hidden.
		<div
			role="status"
			aria-live="polite"
			className={`fixed right-5 top-24 z-[100] border-l-2 bg-mg-black px-5 py-4 font-sans text-sm text-bone transition-opacity duration-300 ease-gallery ${
				show ? "opacity-100" : "pointer-events-none opacity-0"
			} ${type === "success" ? "border-mg-gold" : "border-ink-faint"}`}
		>
			{message}
		</div>
	);
};

export default Notification;
